
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 3 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.471 8.175a.8.8 0 100-1.598.8.8 0 000 1.598zM1.471 2.581a.8.8 0 100-1.598.8.8 0 000 1.598zM1.471 13.77a.8.8 0 100-1.599.8.8 0 000 1.598z","fill":"currentColor"}})])
          )
        }
      }
    